import { FunctionComponent } from 'react';
import TopMenu from '../shared/top-menu/top-menu';
import Footer from '../shared/footer/footer';
import './freetrial.scss';
import OurFormula from './our-formula';
import FreeTrialForm from './freetrial-form';
import H2 from '../shared/html-tags/h2';
import H1 from '../shared/html-tags/h1';
import DIV from '../shared/html-tags/div';
import { Helmet } from 'react-helmet-async';
export type Props = {};

const FreeTrial: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------

  return (
    <>
      <Helmet>
        <title>PS IMAGO PRO - Kostenloser Download der Testversion</title>
        <meta
          name="description"
          content="Teste PS IMAGO PRO kostenlos und unverbindlich. Entdecke die erweiterten Funktionen von PS IMAGO PRO in Kombination mit SPSS Statistics."
        />
        <meta
          name="keywords"
          content="PS IMAGO PRO, Testversion, kostenlos, SPSS Statistics, Predictive Solutions"
        />
        <link rel="canonical" href="https://predictivesolutions.2x4.de/de/freetrial" />
      </Helmet>

      <div className="page freetrial">
        <TopMenu selected="freetrial"></TopMenu>
        <div className="page-content bg-top-freetrial top-banner">
          <div className="inner-content freetrial-top-banner">
            <div className="top-left" style={{ height: 'unset' }}>
              <div className="top-left-2" style={{ marginLeft: '0' }}>
                <H2 language="de">Entdecke den Mehrwert mit PS IMAGO PRO und SPSS Statistics</H2>
                <H1 language="de">
                  Kostenloser Download der
                  <br />
                  Testversion von PS IMAGO PRO
                </H1>
              </div>
            </div>
            <DIV language="de" className="top-right" style={{ display: 'flex' }}>
              <img
                src="/img/freetrial/freetrial-495x500.png"
                alt="Roboter hält eine Waage mit PS IMAGO PRO und SPSS Statistics"
                style={{
                  border: 'none',
                  marginTop: '0',
                  maxHeight: '250px',
                  borderRadius: '0',
                }}
              />
            </DIV>
          </div>
          <div className="inner-content">
            <div className="trial-form">
              <div className="left">
                <OurFormula fontColor="white" />

                <p style={{ marginTop: '3rem' }}>
                  Erlebe die Leistungsfähigkeit von IBM SPSS Statistics in Kombination mit den
                  erweiterten Funktionen von PS IMAGO PRO -{' '}
                  <b>mehr Leistung bei geringeren Kosten</b>
                </p>
                <p>
                  Profitiere von auf einer Software, die auf SPSS aufbaut und speziell entwickelte
                  Funktionen bietet, um das volle Potenzial deiner Datenanalyse zu entfalten.
                </p>
              </div>
              <div className="right" style={{ paddingRight: '2rem' }}>
                <h2 className="form-heading">Unverbindlich testen</h2>
                <FreeTrialForm source="predictivesolutions.2x4.de/freetrial" />
              </div>
            </div>
          </div>
        </div>

        <Footer></Footer>
      </div>
    </>
  );
};

export default FreeTrial;
